import React from 'react';

const Chapter = () => (
  <div className="chapterContainer">
    <p className="currentChapter">Current Chapter</p>
    <p className="chapterName">Chapter 1</p>
    <button type="button" className="btnProgress">Update Progress</button>
  </div>

);

export default Chapter;
